import { SuggestedTextFeatureState } from '../../../@types/state-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ContentStateInterface } from '../../../@types/types'
import { GeneratedSuggestions } from '../../../@types/generate-suggestion-types'

export const initialState: SuggestedTextFeatureState = {
  suggestedTitle: undefined,
  suggestedDescription: undefined,
  suggestedLocation: undefined,
  isTitleManuallyEdited: false,
  isDescriptionManuallyEdited: false,
  isLocationManuallyEdited: false,
  prevInsertionData: {},
}

const suggestedTextFeatureSlice = createSlice({
  name: 'suggestedTextFeature',
  initialState,
  reducers: {
    setPreviousLoadedInsertionData(state, action: PayloadAction<{ insertionData: ContentStateInterface }>) {
      state.prevInsertionData = action.payload.insertionData
    },
    loadAISuggestionSuccess(state, action: PayloadAction<{ suggestions: GeneratedSuggestions }>) {
      const { suggestions } = action.payload

      state.suggestedLocation = suggestions.location
      state.suggestedTitle = suggestions.title
      state.suggestedDescription = suggestions.description
    },
    loadAISuggestionError(state) {
      state.suggestedLocation = undefined
      state.suggestedTitle = undefined
      state.suggestedDescription = undefined
    },
    manuallyEditTitle(state) {
      state.isTitleManuallyEdited = true
    },
    manuallyEditDescription(state) {
      state.isDescriptionManuallyEdited = true
    },
    manuallyEditLocation(state) {
      state.isLocationManuallyEdited = true
    },
    getInsertionInitialCompletionSuccess(state, action: PayloadAction<{ insertionData: ContentStateInterface }>) {
      const { adTitle, adDescription, adLocation } = action.payload.insertionData
      let newFlags = { ...initialState }
      if (adTitle !== undefined) {
        newFlags = { ...newFlags, isTitleManuallyEdited: true }
      }
      if (adDescription !== undefined) {
        newFlags = { ...newFlags, isDescriptionManuallyEdited: true }
      }
      if (adLocation !== undefined) {
        newFlags = { ...newFlags, isLocationManuallyEdited: true }
      }
      state.isTitleManuallyEdited = newFlags.isTitleManuallyEdited
      state.isDescriptionManuallyEdited = newFlags.isDescriptionManuallyEdited
      state.isLocationManuallyEdited = newFlags.isLocationManuallyEdited
    },
  },
})

export const {
  manuallyEditTitle,
  manuallyEditDescription,
  manuallyEditLocation,
  getInsertionInitialCompletionSuccess,
  setPreviousLoadedInsertionData,
  loadAISuggestionSuccess,
  loadAISuggestionError,
} = suggestedTextFeatureSlice.actions
export default suggestedTextFeatureSlice.reducer
